import styled from 'styled-components';
import FormikTextInput from '@/components/core/formik/FormikTextInput';
import Icon from '@/components/core/Icon/Icon';
import { device } from '@/components/Media';

const StyledFormikTextInput = styled(FormikTextInput)`
    max-width: 420px;

    & > div > div {
        padding: 12px;
        height: 48px;
    }

    @media ${device.laptopS} {
        max-width: unset;
    }
`;

export function PasswordInput({
    showPassword,
    setShowPassword,
    ...rest
}) {
    return (
        <StyledFormikTextInput
          autoComplete='new-password'
          type={showPassword ? 'text' : 'password'}
          endAdornment={(
                <Icon name={showPassword ? 'eye-slash-light' : 'eye-light'} onClick={() => setShowPassword(!showPassword)} />
            )}
          {...rest}
        />
    );
}
